import React from 'react';
import "../template-file-css/document-file-template.css";


export const RFS_MonthlySummary = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='RFS_MonthlySummary' className='file-pdf-document'>
            <div className='file-template'>

            <p className='w-750'><center><h3>PRP Monthly Summary</h3></center>
                    <h4>Client Info</h4></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Client ID:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName' name='txtName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtClient' name='txtClient' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Record No:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>MID:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtRecordNo' name='txtRecordNo' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMid' name='txtMid' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Funding Source:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Gender:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtFundingSource' name='txtFundingSource' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male &nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Gender Expression:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>DOB:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtGenderExpression' name='txtGenderExpression' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDateOfBirth' name='txtDateOfBirth' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>SSN:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtSsn' name='txtSsn' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress' name='txtAddress' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>State:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCity' name='txtCity' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtState' name='txtState' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtZip' name='txtZip' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>Phone:</span></td>
                        <td className='w-200'>
                            <span className='eleHeader'>Mobile Phone:</span></td>
                        <td className='w-350'>
                            <span className='eleHeader'>Email:</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtPhone' name='txtPhone' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='text' id='txtMobilePhone' name='txtMobilePhone' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtEmail' name='txtEmail' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Ethnicity:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Race:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtEthnicity' name='txtEthnicity' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtRace' name='txtRace' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Diagnosis/Problems:</span>
                    <textarea id='txtDiagnosisProblems' name='txtDiagnosisProblems' className='add-only'></textarea></p>

                <p className='w-750'><h4>Common Items</h4>
                </p>

                <p className='w-750'><span className='eleHeader'>Participant Accompanied By:</span>
                    <input type='radio' id='rbParticipantAccompanied_Self' name='rbParticipantAccompanied' className='add-only' value='Self' /> Self &nbsp;&nbsp;&nbsp;
                    <input type='radio' id='rbParticipantAccompanied_Family' name='rbParticipantAccompanied' className='add-only' value='Family' /> Family &nbsp;&nbsp;&nbsp;
                    <input type='radio' id='rbParticipantAccompanied_Significant' name='rbParticipantAccompanied' className='add-only' value='Significant' /> Significant Other &nbsp;&nbsp;&nbsp;
                    <input type='radio' id='rbParticipantAccompanied_Legal' name='rbParticipantAccompanied' className='add-only' value='LegalGuardian' /> Legal Guardian  <br />
                    <input type='radio' id='rbParticipantAccompanied_Other' name='rbParticipantAccompanied' className='add-only' value='Other' /> Other: &nbsp;
                    <input type='text' id='txtOther_1' name='txtOther_1' className='add-only w-600 custom-add-only' /> <br />
                    <span className='eleHeader'>Legal Guardian/Custodian Name:</span>
                    <input type='text' id='txtLegalGuardianCustodian' name='txtLegalGuardianCustodian' className='add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'>History of Present Problem(s):</span>
                    <textarea id='txtHistoryOfPresentProblem' name='txtHistoryOfPresentProblem' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Prior MH/SA/DD History:</span>
                    <textarea id='txtPriorHistory' name='txtPriorHistory' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>History of Traumatic Events</span>
                    <textarea id='txtHistoryOfTraumaticEvents' name='txtHistoryOfTraumaticEvents' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Current Living Situation:</span>
                    <textarea id='txtCurrentLivingSituation' name='txtCurrentLivingSituation' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Education History: </span>
                    <textarea id='txtEducationHistory' name='txtEducationHistory' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Vocational History: </span>
                    <textarea id='txtVocationalHistory' name='txtVocationalHistory' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Family History:</span>
                    <textarea id='txtFamilyHistory' name='txtFamilyHistory' className='add-only'></textarea></p>

                <p className='w-750'><h4>Monthly Summary</h4></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Service Code:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Place of Service:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtServiceCode' name='txtServiceCode' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtPlaceOfService' name='txtPlaceOfService' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Start Time:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>End Time:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Service Units Used:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtStartTime' name='txtStartTime' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='time' id='txtEndTime' name='txtEndTime' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtServiceUnitsUsed' name='txtServiceUnitsUsed' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Month/Year:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Place of Service:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMonthYear' name='txtMonthYear' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='radio' id='rbPlaceOfService_Community' name='rbPlaceOfService' className='add-only' value='Community' /> Community &nbsp;
                            <input type='radio' id='rbPlaceOfService_Office' name='rbPlaceOfService' className='add-only' value='Office' /> Office</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Current Rehabilitation Goals</span>
                    <textarea id='txtCurrentRehabilitationGoals' name='txtCurrentRehabilitationGoals' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Please describe the progress client has made towards age-appropriate development, more independent functioning, and independent living skills.</span>
                    <textarea id='txtPleaseDescribeTheProgress' name='txtPleaseDescribeTheProgress' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Client Assessment Towards Progress on Goals</span>
                    <textarea id='txtClientAssessmentTowardsProgressOnGoals' name='txtClientAssessmentTowardsProgressOnGoals' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Justification for Need of Ongoing PRP Services</span>
                    <textarea id='txtJustificationForNeed' name='txtJustificationForNeed' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Referrals Provided This Month</span>
                    <input type='radio' id='rbReferralsProvidedThisMonth_Yes' name='rbReferralsProvidedThisMonth' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReferralsProvidedThisMonth_No' name='rbReferralsProvidedThisMonth' className='add-only' value='No' /> No <br />
                    <textarea id='txtReferralsProvidedThis' name='txtReferralsProvidedThis' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Education Provided This Month</span>
                    <input type='radio' id='rbEducationProviderThisMonth_Yes' name='rbEducationProviderThisMonth' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbEducationProviderThisMonth_No' name='rbEducationProviderThisMonth' className='add-only' value='No' /> No <br />
                    <textarea id='txtEducationProvidedThisMonth' name='txtEducationProvidedThisMonth' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Last Session</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Dose client continue to attend therapy Sessions?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtDateOfLastSession' name='txtDateOfLastSession' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='radio' id='rbDoseClientLastSession_Yes' name='rbDoseClientLastSession' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDoseClientLastSession_No' name='rbDoseClientLastSession' className='add-only' value='No' /> No</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Therapist Name</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone Number</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtTherapistName' name='txtTherapistName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhoneNumber' name='txtPhoneNumber' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Any Significant changes or events that affect the individual's rehabilitation?</span>
                    <textarea id='txtAnySignificantChangesOrEvent' name='txtAnySignificantChangesOrEvent' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Please explain if the client is at risk for being removed from their current environments i.e. suspended/expelled; arrested/confined; hospitalized; kicked-out, etc. </span>
                    <textarea id='txtPleaseExplainIfTheClientIsAtRiskFor' name='txtPleaseExplainIfTheClientIsAtRiskFor' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Rehabilitation Activities used this month:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRehabilitationsActivitiesUsedThisMonth_1' name='cbRehabilitationsActivitiesUsedThisMonth_1' className='add-only' value='Anger' /> Age appropriate self-care skills (personal hygiene, grooming, nutrition, dietary planning, food
                            preparation, self- administration of medication)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRehabilitationsActivitiesUsedThisMonth_2' name='cbRehabilitationsActivitiesUsedThisMonth_2' className='add-only' value='Anger' /> Social skills (community integration activities, developing natural supports, developing linkages
                            with and supporting the clients participation in community activities)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRehabilitationsActivitiesUsedThisMonth_3' name='cbRehabilitationsActivitiesUsedThisMonth_3' className='add-only' value='Anger' /> Independent living skills (maintenance of the living environment, community awareness,
                            mobility skills, money management, accessing available entitlements) </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRehabilitationsActivitiesUsedThisMonth_4' name='cbRehabilitationsActivitiesUsedThisMonth_4' className='add-only' value='Anger' /> Activities that support the minor's cultural interests ( sports, academic matriculation)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRehabilitationsActivitiesUsedThisMonth_5' name='cbRehabilitationsActivitiesUsedThisMonth_5' className='add-only' value='Anger' /> Conflict resolution</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRehabilitationsActivitiesUsedThisMonth_6' name='cbRehabilitationsActivitiesUsedThisMonth_6' className='add-only' value='Anger' /> Anger management</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRehabilitationsActivitiesUsedThisMonth_7' name='cbRehabilitationsActivitiesUsedThisMonth_7' className='add-only' value='Anger' /> Interactive skills with peers and authority figures</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRehabilitationsActivitiesUsedThisMonth_8' name='cbRehabilitationsActivitiesUsedThisMonth_8' className='add-only' value='Anger' /> Maintaining personal living space</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRehabilitationsActivitiesUsedThisMonth_9' name='cbRehabilitationsActivitiesUsedThisMonth_9' className='add-only' value='Anger' /> Maintaining age- appropriate boundaries</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRehabilitationsActivitiesUsedThisMonth_10' name='cbRehabilitationsActivitiesUsedThisMonth_10' className='add-only' value='Anger' /> Maintaining personal safety in a social environment</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRehabilitationsActivitiesUsedThisMonth_11' name='cbRehabilitationsActivitiesUsedThisMonth_11' className='add-only' value='Anger' /> Time management (including constructive use of structured and unstructured time)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRehabilitationsActivitiesUsedThisMonth_12' name='cbRehabilitationsActivitiesUsedThisMonth_12' className='add-only' value='Anger' /> Medication management</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRehabilitationsActivitiesUsedThisMonth_13' name='cbRehabilitationsActivitiesUsedThisMonth_13' className='add-only' value='Anger' /> Mobility and transportation skills</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRehabilitationsActivitiesUsedThisMonth_14' name='cbRehabilitationsActivitiesUsedThisMonth_14' className='add-only' value='Anger' /> Obtaining/ retaining employment</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRehabilitationsActivitiesUsedThisMonth_15' name='cbRehabilitationsActivitiesUsedThisMonth_15' className='add-only' value='Anger' /> Housing Stability</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRehabilitationsActivitiesUsedThisMonth_16' name='cbRehabilitationsActivitiesUsedThisMonth_16' className='add-only' value='Anger' /> Wellness self management</td>
                    </tr>
                </table>




                
            </div>
        </form>
    )
}